import React from "react";
import MainSubtitle from "../components/MainSubtitle";
import GalleryI from "../components/GalleryI";

function Gallery() {
    return (
        <main>
            <MainSubtitle />
            <GalleryI />
        </main>
    )
}

export default Gallery;